module.exports = __webpack_public_path__ + "img/icons BFr_13.f25c8abf.svg";